import { render, staticRenderFns } from "./LabelAdd.vue?vue&type=template&id=be13209e&scoped=true"
import script from "./LabelAdd.vue?vue&type=script&lang=js"
export * from "./LabelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be13209e",
  null
  
)

export default component.exports